<template>
    <div v-if="isLoaded && formUserInfo">
        <div class="flex justify-center items-center">
        <InputText
            class="mr-4"
            v-model:inputValue="formUserInfo.firstName"
            :maxLength="50"
            :minLength="2"
            :isTextOnly="true"
            :errorInfo="formErrorInfo[0]"
            :inputLbl="formLbl.firstname"
            :isSubmitted="isSubmitted"
            :isShowError="isShowError"
            @onChange="onValidateForm()"
        ></InputText>
        <InputText
            v-model:inputValue="formUserInfo.lastName"
            :maxLength="50"
            :minLength="2"
            :isTextOnly="true"
            :errorInfo="formErrorInfo[1]"
            :isSubmitted="isSubmitted"
            :isShowError="isShowError"
            :inputLbl="formLbl.lastname"
            @onChange="onValidateForm()"
        ></InputText>
        </div>
        <div class="w-full">
            <InputEmail
                v-model:inputValue="formUserInfo.email"
                :maxLength="50"
                :errorInfo="formErrorInfo[2]"
                :isSubmitted="isSubmitted"
                :isShowError="isShowError"
                :inputLbl="formLbl.email"
                :isDisable="isDisable"
                @onChange="onValidateForm()"
            >
            </InputEmail>

            <div @click="showChangeNumberModal()">
                <InputContactNumber
                    v-if="isReloadContactNumber"
                    v-model:inputValue="formUserInfo.contactNumber"
                    :minLength="12"
                    :maxLength="12"
                    delimeter="-"
                    :errorInfo="formErrorInfo[3]"
                    :isSubmitted="isSubmitted"
                    :isShowError="isShowError"
                    :inputLbl="formLbl.contactNumber"
                    @onChange="onValidateForm()"
                >
                </InputContactNumber>
            </div>
            <!-- Start Thai Id -->
            <ShowThaiId
                v-if="isHaveThaiId()"
                :inputLbl="formLbl.idCard"
                :isDisable="true"
                :displayThaiId="showIdcard"
            >
            </ShowThaiId>
            <InputNationalId
                v-else
                v-model:inputValue="formUserInfo.idcard"
                :errorInfo="formErrorInfo[4]"
                :isSubmitted="isSubmitted"
                :isShowError="isShowError"
                :inputLbl="formLbl.idCard"
                @onChange="onValidateForm()"
            >
            </InputNationalId>

            <!-- End Thai Id -->
            <InputRadio
                v-model:inputValue="formUserInfo.gender"
                :itemList="genderList"
                :errorInfo="formErrorInfo[5]"
                :isSubmitted="isSubmitted"
                :isShowError="isShowError"
                :inputLbl="formLbl.gender"
                @onChange="onValidateForm()"
            >
            </InputRadio>
            <!-- Birthdate -->
            <DatePickerDropdown
                v-model:inputValue="formUserInfo.birthDate"
                :errorInfo="formErrorInfo[6]"
                :isSubmitted="isSubmitted"
                :isShowError="isShowError"
                :inputLbl="formLbl.birthdate"
                :isFormUser="true"
                @onChange="onValidateForm()"
            ></DatePickerDropdown>
            <!-- Birthdate -->
            <div class="grid grid-cols-2 gap-x-4">
                <InputText
                    v-model:inputValue="formUserInfo.number"
                    :maxLength="50"
                    :errorInfo="formErrorInfo[7]"
                    :isShowError="isShowError"
                    :isSubmitted="isSubmitted"
                    :inputLbl="formLbl.number"
                ></InputText>
                <InputText
                    v-model:inputValue="formUserInfo.soi"
                    :maxLength="50"
                    :errorInfo="formErrorInfo[8]"
                    :isShowError="isShowError"
                    :isSubmitted="isSubmitted"
                    :inputLbl="formLbl.soi"
                ></InputText>
                <InputText
                    v-model:inputValue="formUserInfo.road"
                    :maxLength="50"
                    :errorInfo="formErrorInfo[9]"
                    :isShowError="isShowError"
                    :isSubmitted="isSubmitted"
                    :inputLbl="formLbl.road"
                ></InputText>
                <InputNumber
                    v-model:inputValue="formUserInfo.zipcode"
                    :minLength="5"
                    :maxLength="5"
                    :errorInfo="formErrorInfo[10]"
                    :isShowError="isShowError"
                    :isSubmitted="isSubmitted"
                    :inputLbl="formLbl.zipcode"
                    @update:inputValue="onZipcodeChange()"
                ></InputNumber>
            </div>
            <div class="w-full">
                <FormAddressDropdown
                    ref="addresDropdown"
                    v-model:inputValue="formUserInfo"
                    :isSubmitted="isSubmitted"
                    :isShowError="isShowError"
                    :errorInfo="formErrorInfo[11]"
                    :inputLbl="formLbl"
                    @onChange="onValidateForm()"
                >
                </FormAddressDropdown>
            </div>
        </div>
    </div>
</template>
<script>
// helper
import { DropdownListValue, FormHelper } from '@/helper/FormHelper.js';
import Util from '@/helper/Utility';
// core
import { UserInfoModel } from '@/core/Account/model/UserInfoModel.js';
// component

import InputText from '../Input/label/InputText.vue';
import InputEmail from '../Input/label/InputEmail.vue';
import InputNumber from '../Input/label/InputNumber.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import InputNationalId from '@/components/Input/label/InputNationalId.vue';
import InputRadio from '@/components/Input/label/InputRadio.vue';
import FormAddressDropdown from './FormAddressDropdown.vue';
// mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import DatePickerDropdown from '../Input/label/DatePickerDropdown.vue';
import ShowThaiId from '@/module/Profile/component/ShowThaiId.vue';

export default {
    name: "FormUserInfo",
    mixins:[AuthStatusMixin],
    props: {
        // v-model
        formValid: { type: Boolean },
        // props
        userInfo: { type: Object, default: null },
        // errorInfo: { type: Object, required: true },
        isShowError: { type: Boolean, required: true },
        isSubmitted: { type: Boolean, required: true },
        // text
        formLbl: { type: Object, required: true },

        isDisable: { type: Boolean, default: false },

        modalController: Object,
    },
    components: {
    InputText,
    InputEmail,
    InputContactNumber,
    InputNationalId,
    InputRadio,
    FormAddressDropdown,
    InputNumber,
    DatePickerDropdown,
    ShowThaiId,
},
    data: function () {
        return {
            // page
            isLoaded: false,
            // variable
            formErrorInfo: [],
            formUserInfo: new UserInfoModel(),
            genderList: new DropdownListValue(),

            newNumber: "",
            isReloadContactNumber: true,
        };
    },
    created: function () {
        this.formErrorInfo = FormHelper.genErrorInfo(12);
        this.initUserInfo();
        this.initGenderList();
        this.isLoaded = true;
        this.$nextTick(() => {
            this.onZipcodeChange();
        });
    },
    computed: {
        displayThaiId: function() {
            let thaiId = this.userInfo.idcard
            return thaiId
        },
    },
    methods: {
        isHaveBirthDate: function() {
            if (Util.isEmptyStr(this.userInfo.birthDate)) return false
            this.showBirthdate = this.userInfo.birthDate;
            return true
        },
        isHaveThaiId: function () {
            // ไม่มีเลข หรือ checkupdateprofile = false
            if (Util.isEmptyStr(this.userInfo.idcard) || !this.formUserInfo.checkupdateprofile) {
                return false
            }
            // มีเลข
            this.showIdcard = this.userInfo.idcard;
            return true
        },
        //#region event
        onValidateForm: function () {
            const isValid = FormHelper.validate(this.formErrorInfo);
            this.$emit("update:formValid", isValid);
        },
        //#endregion event
        //#region init
        initUserInfo: function () {
            if (!this.userInfo)
                return;
            this.formUserInfo = {...this.userInfo};
        },
        initGenderList: function () {
            let list = new DropdownListValue();
            list.add(this.formLbl.female, "female");
            list.add(this.formLbl.male, "male");
            this.genderList = list.getList();
        },
        //#endregion init
        //#region method
        getFormData: function () {
            if (this.formValid) {
                return this.formUserInfo;
            }
            else {
                return null;
            }
        },
        //#endregion method
        onZipcodeChange: function() {
            this.$refs['addresDropdown'].onZipcodeChange(this.formUserInfo.zipcode);
        },
        reLoadContactNumberInput: function (data) {
            this.formUserInfo.contactNumber = data.change_contact_number;
            this.isReloadContactNumber = false;
            this.$nextTick(() => {
                this.isReloadContactNumber = true;
            });
        },
        showChangeNumberModal:async function() {
            this.tracking.event('profile', 'click_change_mobile');
            this.modalController.changeMobileNumberModal
                .setTitle(this.formLbl.mobile_number.name)
                .setMobileNumber(this.formUserInfo.contactNumber)
                .show();

            this.modalController.changeMobileNumberModal.onClickOk(async objData => {
                this.tracking.event('profile', 'click_confirm_otp');
                this.objData = objData;

                    this.modalController.loadingModal.show();
                    this.AccountStore.methods.getProfileCustom();
                    this.modalController.loadingModal.hide();
                    this.modalController.changeMobileNumberModal.hide();
                    this.reLoadContactNumberInput(this.objData);

                    this.modalController.alertModal
                        .setMsg('คุณได้เปลี่ยนเบอร์โทรศัพท์สำเร็จแล้ว')
                        .show();
            })
            this.modalController.changeMobileNumberModal.onError( () => {

                this.modalController.changeMobileNumberModal
                    .clearModal()
                    .hide();
                this.modalController.alertModal
                    .clearModal()
                    .setMsg('เบอร์โทรศัพท์นี้ เคยลงทะเบียนแล้ว กรุณาตรวจสอบเบอร์โทรศัพท์ของคุณอีกครั้ง')
                    .show();

            })

        },

        submit: function() {
            if (this.validate()) {
                return this.formUserInfo;
            }
            return null;
        },
        validate: function() {
            for (let i of this.formErrorInfo) {
                if (!i.isValid) {
                    this.modalController.alertModal
                            .clearModal()
                            .setMsg(i.msg)
                            .show();
                    return false;
                }
            }
            return true;
        },
    },
}
</script>
